export { App as default } from '@guiker/listing-main-mfe'
